import script from "./comicList_1.vue?vue&type=script&setup=true&lang=js"
export * from "./comicList_1.vue?vue&type=script&setup=true&lang=js"

import "./comicList_1.vue?vue&type=style&index=0&id=0d8eedfc&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8eedfc"]])

export default __exports__